/**
 * Shared logic between AngularJS and Angular HTTP interceptors.
 * This module contains pure functions that can be used by both.
 */

export interface ElevationRequiredError {
  error?: {
    code?: string;
  };
}

export interface FraudCheckData {
  fraud?: boolean;
  userProfile?: {
    fraud?: boolean;
  };
}

export const SESSION_TIMEOUT_STATUS = 419;
export const IDENTITY_TOKEN_HEADER = 'LTIdentityToken';
export const DEFAULT_HTTP_TIMEOUT = 90000;

export function isElevationRequired(responseData: ElevationRequiredError | null | undefined): boolean {
  return !!responseData?.error && responseData.error.code === 'ELEVATION_REQUIRED';
}

export function isUserProfileUrl(url: string | undefined): boolean {
  if (!url) return false;
  return url.includes('/userProfile/login') || url.includes('/userProfile/getUserProfile');
}

export function isFraudDetected(data: FraudCheckData | null | undefined): boolean {
  if (!data) return false;
  return !!(data.fraud ?? data.userProfile?.fraud);
}

export function isSessionTimeoutStatus(status: number): boolean {
  return status === SESSION_TIMEOUT_STATUS;
}
